import { useMemo } from 'react'
import { useProductCard } from '../useProductCard'

export const useSelectedColor = () => {
	const { selectedColorId, productColors } = useProductCard()

	const selectedColor = useMemo(
		() => productColors.find((item) => item.id === selectedColorId),
		[productColors, selectedColorId]
	)

	return useMemo(() => ({ selectedColor }), [selectedColor])
}
